module.exports = __webpack_public_path__ + "img/news_trplus.f44a8236.svg";